export default [
  {
    path: '/admin/dashboard',
    name:'dashboard',
    component:()=> import('@/views/pages/cloudx/dashboard/Dashboard')
  },
]
